import LinkIcon from '@/assets/icons/link-out.svg?react';
import SiemensLogo from '@/assets/icons/siemens.svg?react';
import PLMLogo from '@/assets/plm-logo.png';

import { T } from '@/components/i18n/message.i18n.component';
import Button from '@/components/ui/button/button.component';

import APP_CONFIG from '@/_config/config.app';
import { Footer } from '@/components/elements/footer/footer.component';
import { UnauthenticatedTemplate, useMsal } from '@azure/msal-react';
import { loginPageMessages } from './login.messages';
import { commonMessages } from '@/__scripts/common.messages';

type Env = 'dev' | 'test' | 'qa' | 'prod';

const DIRX_PROD_INSTRUCTIONS_PATH = '/dirx-prod.pdf';

const BASE_DIRX_URL = 'https://core.siemens.cloud/ui/dirx/roles?domain=HRS&subPath=E2E%20Process%20Navigator,';

const REQUEST_ACCESS_URLS: Record<Env, string> = {
  dev: `${BASE_DIRX_URL}Development%20System,N%2FA,Consumer`,
  test: `${BASE_DIRX_URL}Test%20System,N%2FA,Consumer`,
  qa: `${BASE_DIRX_URL}Test%20System,N%2FA,Consumer`,
  prod: `${BASE_DIRX_URL}Productive%20System,N%2FA,Consumer`,
};

export const LoginPage = () => {
  const { instance } = useMsal();
  const handleRedirect = () => {
    instance.loginRedirect({
      scopes: [],
    });
  };

  const handleRequestAccess = () => {
    const url = REQUEST_ACCESS_URLS[import.meta.env.VITE_ENV as Env] ?? REQUEST_ACCESS_URLS.dev;
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  const handleServicePortal = () => {
    window.open(APP_CONFIG.LINKS.SERVICE_PORTAL_LINK, '_blank', 'noopener,noreferrer');
  };

  const handleTutorial = () => {
    window.open(APP_CONFIG.LINKS.TUTORIAL_LINK, '_blank', 'noopener,noreferrer');
  };

  const handleOnboarding = () => {
    window.open(DIRX_PROD_INSTRUCTIONS_PATH, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="bg-light-gray h-full w-full fixed flex flex-col items-center justify-center">
      <UnauthenticatedTemplate>
        <div className="bg-white w-[460px] shadow">
          <div className="flex flex-col p-6">
            <SiemensLogo className="h-[32px] w-[114px] fill-primary mb-4" />
            <div className="flex flex-row items-center mb-8">
              <img
                aria-label="Application Logo"
                role="img"
                data-testid="navbar-app-logo"
                src={PLMLogo}
                className="w-5 h-5 mr-1"
              />
              <h1>
                <T {...loginPageMessages.title} />
              </h1>
            </div>
            <Button variant="default" onClick={handleRedirect}>
              <T {...loginPageMessages.button} />
            </Button>
          </div>
          <div className="flex flex-row items-center">
            <div className="bg-other-stroke h-[2px] w-full" />
            <p className="px-5">
              <T {...loginPageMessages.or} />
            </p>
            <div className="bg-other-stroke h-[2px] w-full" />
          </div>
          <div className="flex flex-col p-6">
            <Button variant="secondary" onClick={handleRequestAccess}>
              <T {...loginPageMessages.requestAccess} />
            </Button>
          </div>
          <div className="px-6 py-4 border-t border-other-stroke flex flex-row gap-x-5">
            <Button
              className="typo-secondary text-secondary-text flex gap-x-1"
              variant="ghost"
              onClick={handleOnboarding}
            >
              <T {...loginPageMessages.dirXManual} />
              <LinkIcon className="ml-1" />
            </Button>
            <Button
              className="typo-secondary text-secondary-text flex gap-x-1"
              variant="ghost"
              onClick={handleServicePortal}
            >
              <T {...loginPageMessages.servicePortal} />
              <LinkIcon />
            </Button>
            <Button
              className="typo-secondary text-secondary-text flex gap-x-1"
              variant="ghost"
              onClick={handleTutorial}
            >
              <T {...commonMessages.tutorial} />
              <LinkIcon />
            </Button>
          </div>
        </div>
      </UnauthenticatedTemplate>
      <Footer />
    </div>
  );
};
